import { ref } from "vue";

/**
 * 画面ロジックを扱う composable。
 */
export const useMemberSearchForm = () => {
  // お名前(漢字・かな)
  const searchConditionName = ref<string | undefined | null>(null);

  // 電話番号
  const searchConditionPhone = ref<string | undefined | null>(null);

  // 郵便番号
  const searchConditionZipCode = ref<string | undefined | null>(null);

  // ハウスカード番号
  const searchConditionHouseCard = ref<string | undefined | null>(null);

  return {
    searchConditionName,
    searchConditionPhone,
    searchConditionZipCode,
    searchConditionHouseCard,
  };
};
